/* v4.1 · flags when the scroll stage is pinned on screen (used to tuck the theme's sticky buy bar away on phones). */
(function () {
  if (window.__lgndStoryV4) return; window.__lgndStoryV4 = true;
  var stage = document.querySelector('[data-ls-stage]');
  if (!stage) return;
  var root = document.documentElement, ticking = false;
  function check() {
    ticking = false;
    var r = stage.getBoundingClientRect();
    root.classList.toggle('ls-stage-on', r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight * 0.5);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  window.addEventListener('resize', check);
  check();
})();

/* v5 · film opens from an inset card to full width as it reaches the middle of the screen. */
(function () {
  if (window.__lgndStoryV5) return; window.__lgndStoryV5 = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var films = document.querySelectorAll('[data-ls-film]');
  if (!films.length) return;
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    films.forEach(function (f) {
      var clip = f.querySelector('.ls-film2__clip'); if (!clip) return;
      var r = clip.getBoundingClientRect();
      var p = (vh - r.top) / (vh * 0.5 + r.height * 0.5);
      p = Math.min(1, Math.max(0, p)); p = p * p * (3 - 2 * p);
      f.style.setProperty('--fp', p.toFixed(3));
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* v5 · inline CTAs: mirror the picked variant (name, price, entries) and add it via the theme's own buy button. */
(function () {
  if (window.__lgndStoryCta) return; window.__lgndStoryCta = true;
  var ctas = document.querySelectorAll('[data-ls-cta]');
  if (!ctas.length) return;
  function fmt(n) { n = parseInt(n, 10); return isNaN(n) ? '' : n.toLocaleString('en-US'); }
  function inputs() { return document.querySelectorAll('variant-picker[context="main_product"] input[type="radio"]'); }
  function info(val) {
    var el = document.querySelector('[data-ls-build="' + val + '"]') || document.querySelector('[data-ls-var="' + val + '"]');
    return el ? { name: el.getAttribute('data-name'), price: el.getAttribute('data-price'), entries: el.getAttribute('data-entries'), available: el.getAttribute('data-available') === 'true' } : null;
  }
  var picks = document.querySelectorAll('[data-ls-cta-pick]');
  function paint() {
    var on = Array.prototype.filter.call(inputs(), function (i) { return i.checked; })[0];
    if (on) picks.forEach(function (t) { var a = t.getAttribute('data-ls-cta-pick') === on.value; t.classList.toggle('is-active', a); t.setAttribute('aria-checked', a ? 'true' : 'false'); });
    var d = on && info(on.value); if (!d) return;
    ctas.forEach(function (c) {
      var n = c.querySelector('[data-ls-cta-name]'), p = c.querySelector('[data-ls-cta-price]'), e = c.querySelector('[data-ls-cta-ent]'), b = c.querySelector('[data-ls-cta-btn]');
      if (n) n.textContent = d.name; if (p) p.textContent = d.price;
      if (e) { e.textContent = fmt(d.entries); e.parentElement.classList.toggle('is-hidden', !d.entries); }
      if (b) { if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent.trim()); b.disabled = !d.available; b.textContent = d.available ? b.getAttribute('data-label') : 'Sold out'; }
    });
  }
  function hold(ms) {
    var y = window.pageYOffset, until = Date.now() + ms;
    (function g() { if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo(0, y); if (Date.now() < until) requestAnimationFrame(g); })();
  }
  ctas.forEach(function (c) {
    var b = c.querySelector('[data-ls-cta-btn]'); if (!b) return;
    b.addEventListener('click', function () {
      var btn = document.querySelector('button[type="submit"][form^="product-form-main"]') || document.querySelector('form[id^="product-form-main"] button[type="submit"]');
      if (btn && !btn.disabled) { hold(1200); btn.click(); }
    });
  });
  picks.forEach(function (t) {
    t.addEventListener('click', function () {
      var v = t.getAttribute('data-ls-cta-pick');
      var input = Array.prototype.filter.call(inputs(), function (i) { return i.value === v; })[0];
      if (!input || input.checked) return;
      hold(1000);
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker[context="main_product"]')) setTimeout(paint, 0); });
  paint();
})();

/* v6 · scroll rail: any colour row that runs off the screen gets a slim track + arrows under it, so shoppers can
   see there are more options. Shows only when the row actually overflows (3-variant products never see it). */
(function () {
  if (window.__lgndStoryRail) return; window.__lgndStoryRail = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rows = document.querySelectorAll('.ls-give2__vars, .ls-stage--expand .ls-picker__chips, [data-ls-rail]');
  if (!rows.length) return;
  var arrow = function (d) { return '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="' + (d < 0 ? 'M10 3L5 8l5 5' : 'M6 3l5 5-5 5') + '" stroke="currentColor" stroke-width="2"/></svg>'; };
  rows.forEach(function (row) {
    var rail = document.createElement('div');
    rail.className = 'ls-rail';
    rail.innerHTML = '<button type="button" class="ls-rail__btn" data-dir="-1" aria-label="Previous options" tabindex="-1">' + arrow(-1) + '</button>' +
      '<div class="ls-rail__track"><i class="ls-rail__thumb"></i></div>' +
      '<button type="button" class="ls-rail__btn" data-dir="1" aria-label="More options" tabindex="-1">' + arrow(1) + '</button>';
    row.parentNode.insertBefore(rail, row.nextSibling);
    var track = rail.querySelector('.ls-rail__track'), thumb = rail.querySelector('.ls-rail__thumb');
    var btns = rail.querySelectorAll('.ls-rail__btn');
    function paint() {
      var max = row.scrollWidth - row.clientWidth;
      var over = max > 4;
      rail.hidden = !over;
      if (!over) return;
      var w = Math.max(12, (row.clientWidth / row.scrollWidth) * 100);
      var x = (row.scrollLeft / max) * (100 - w);
      thumb.style.width = w + '%';
      thumb.style.left = x + '%';
      btns[0].disabled = row.scrollLeft < 4;
      btns[1].disabled = row.scrollLeft > max - 4;
    }
    function go(left) { row.scrollTo ? row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }) : (row.scrollLeft = left); }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { go(row.scrollLeft + parseInt(b.getAttribute('data-dir'), 10) * row.clientWidth * 0.8); });
    });
    track.addEventListener('click', function (e) {
      var r = track.getBoundingClientRect();
      go(((e.clientX - r.left) / r.width) * (row.scrollWidth - row.clientWidth));
    });
    row.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    if (window.ResizeObserver) new ResizeObserver(paint).observe(row);
    paint();
  });
})();
